// People
import BoyImg from "./Assets/People/photo_boy.webp"
import GirlImg from "./Assets/People/photo_girl.webp"
import OldImg from "./Assets/People/photo_old.webp"
import ManImg from "./Assets/People/photo_man.webp"
import WomanImg from "./Assets/People/photo_woman.webp"
// Phone
import Profesak from "./Assets/Phone/collage__profesak.webp"
import Auto from "./Assets/Phone/collage_autoskola.webp"
import Fish from "./Assets/Phone/collage_fish.webp"
import Straz from "./Assets/Phone/collage_straznik.webp"
import Zbroj from "./Assets/Phone/collage_zbrojak.webp"
//import Urednik from "./Assets/Phone/collage_urednik.webp"
// Candy Math
import CandyTitle from "./Assets/CandyMath/title.webp"
import CandyPromo from "./Assets/CandyMath/promo.webp"
// Gemstone
import GemTitle from "./Assets/Gemstone/gemtitle.webp"
import GemPromo from "./Assets/Gemstone/gempromo.webp"

import { appDarkBlue, appGreen, navbarBlue } from "../Classes/theme"

export const about_apps = [
    { link: '/autoskola', title: 'Autoškola', text: <><b>Usnadněte si přípravu</b> na závěrečnou zkoušku v autoškole. Aplikace nabízí aktuální otázky, cvičné testy a režimy pro efektivní zapamatování.</>, offersImage: Auto },
    { link: '/zbrojak', title: 'Zbrojní průkaz', text: <>S aplikací Zbrojní průkaz zvládnete zkoušku odborné způsobilosti <b>snadno a efektivně</b>. Najdete zde všechny aktuální otázky, cvičné testy a studijní režimy, díky kterým se vše rychle naučíte.</>, offersImage: Zbroj },
    { link: '/straznik', title: 'Zkouška strážníka', text: <><b>Ulehčete si přípravu</b> k profesní zkoušce. Aplikace obsahuje aktuální otázky a efektivní studijní režimy pro systematické testování vašich znalostí.</>, offersImage: Straz },
    //{ link: '/urednik', title: 'Úřednická zkouška', text: <>S aplikací na úřednickou zkoušku zvládnete přípravu <b>rychle a přehledně</b>. Oficiální otázky, testy a chytré studijní módy vám pomohou uspět.</>, offersImage: Urednik },
    { link: '/profesak', title: 'Profesní průkaz', text: <>Získejte profesní průkaz <b>snadno a bez námahy</b>. Aplikace nabízí aktuální otázky, cvičné testy a studijní režimy pro efektivní zapamatování.</>, offersImage: Profesak },
    { link: '/rybar', title: 'Zkouška rybáře', text: <>Aplikace Rybářské zkoušky vám pomůže s přípravou na test pro získání rybářského lístku. Obsahuje aktuální otázky a studijní režimy, díky kterým zkoušku hravě zvládnete.</>, offersImage: Fish },
];


const oftenAsked = [{
    title: "Jsou otázky v aplikaci aktuální?",
    text: (
        <>Ano, aplikace pracuje s nejnovějšími oficiálními otázkami. Otázky pravidelně aktualizujeme, aby odpovídaly současným testům a legislativě, na kterou se vztahují příslušné zkoušky.</>
    ),
}, {
    title: "Jak fungují studijní módy Drill, RePlay a Test?",
    text: (
        <>Drill slouží k systematickému procvičování – otázky se opakují, dokud nejsou správně zodpovězeny. RePlay se zaměřuje na otázky, které jste v minulosti zodpověděli chybně. Test pak simuluje reálnou zkoušku – uspějete pouze, pokud uděláte maximálně tři chyby.</>
    ),
}, {
    title: "Můžu si aplikaci bezplatně vyzkoušet?",
    text: (
        <>Ano, všechny naše aplikace jsou zdarma ke stažení a nabízejí širokou škálu funkcí pro přípravu na zkoušku. Zdarma si vyzkoušíte studijní módy, procvičíte otázky a můžete absolvovat zkoušku nanečisto. </>
    ),
}, {
    title: "Jsou vaše aplikace dostupné pro iOS i Android?",
    text: (
        <>Ano, aplikace jsou plně dostupné pro obě hlavní mobilní platformy – iOS i Android. Stáhnout si je můžete jednoduše přes App Store nebo Google Play. Aplikace pravidelně aktualizujeme a zajišťujeme jejich správné fungování na všech běžných zařízeních.</>
    ),
},]

//#region Main Page

export const mainPage = {
    color: navbarBlue,
    link: '/',
    // Header
    img: GirlImg,
    smTitle: <></>,
    title: <>S aplikací zvládnete testy snadno</>,
    text: <>Studijní aplikace na každou zkoušku</>,
    buttonText: <>Více</>,
    // Download links
    googleLink: '',
    appstoreLink: '',
    // Advantages
    advantages: [0, 0, 0, 0],
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Autoškola Plus',
    dText: 'Autoškola Plus usnadňuje uchazečům o řidičský průkaz přípravu na závěrečnou zkoušku v autoškole. Aplikace nabízí aktuální sadu testových otázek potřebnou k úspěšnému absolvování závěrečné zkoušky, moderní přístup ke studijnímu procesu a pomáhá uživateli vstřebat velké množství otázek snadnou a hravou formou.',
    // AppOffers
    offers: [<><b>Zkušební okruhy</b> na závěrečnou zkoušku pro řidičské oprávnění skup. A,B,C a D</>,
    <><b>Všechny otázky</b> včetně obrázkové grafiky</>,
    <>Možnost vyzkoušet <b>závěrečnou zkoušku nanečisto</b></>,
    <><b>Možnost testovat jednotlivé skupiny otázek</b></>,
    <>Možnost promíchání otázek </>,
    <><b>Statistiky</b> úspěšnosti v jednotlivých lekcích a cvičné zkoušce</>,
    <><b>Systém studijních módů</b> pro snadné učení</>,
    <>Využití metody přerušovaného učení (<b>spaced repetition</b>)</>,
    <>Systém motivačního hodnocení a odměn</>],
    offersImage: Auto,
    // Often asked
    oftenAsked,
};

//#endregion
//#region App Pages

export const appPages = [{
    color: navbarBlue,
    link: '/autoskola',
    // Header
    img: BoyImg,
    smTitle: <>Autoškola</>,
    title: <>S aplikací zvládnete autoškolu snadno</>,
    text: <>Usnadněte si přípravu na zkoušku v autoškole</>,
    buttonText: <>Stáhnout</>,
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Autoškola Plus',
    dText: 'Autoškola Plus usnadňuje uchazečům o řidičský průkaz přípravu na závěrečnou zkoušku v autoškole. Aplikace nabízí aktuální sadu testových otázek potřebnou k úspěšnému absolvování závěrečné zkoušky, moderní přístup ke studijnímu procesu a pomáhá uživateli vstřebat velké množství otázek snadnou a hravou formou.',
    // Download links
    googleLink: 'https://play.google.com/store/apps/details?id=com.metastream.autoskolaplus',
    appstoreLink: 'https://apps.apple.com/us/app/auto%C5%A1kola-plus-2025/id1535805369',
    // Advantages
    advantages: [0, 0, 0, 0],
    // AppOffers
    offers: [<><b>Zkušební okruhy</b> na závěrečnou zkoušku pro řidičské oprávnění skupin A, B, C a D</>,
    <><b>Všechny otázky</b> včetně obrázkové grafiky</>,
    <>Možnost vyzkoušet si <b>závěrečnou zkoušku nanečisto</b></>,
    <><b>Možnost studovat vybrané skupiny otázek</b></>,
    <>Možnost promíchání otázek</>,
    <><b>Statistiky</b> úspěšnosti v jednotlivých lekcích a cvičné zkoušce</>,
    <><b>Systém studijních módů</b> pro snadné učení</>,
    <>Využití metody přerušovaného učení (<b>spaced repetition</b>)</>,
    <>Systém motivačního hodnocení a odměn</>],
    offersImage: Auto,
    // Often asked
    oftenAsked
},
{
    color: appGreen,
    link: '/zbrojak',
    // Header
    img: OldImg,
    smTitle: <>Zbrojní průkaz</>,
    title: <>Získejte zbrojní průkaz snadno</>,
    text: <>Usnadněte si přípravu na teoretickou část zkoušky odborné způsobilosti</>,
    buttonText: <>Stáhnout</>,
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Zbrojní průkaz',
    dText: 'Zbrojní průkaz Plus je aplikace, která si klade za cíl uchazečům o zbrojní průkaz maximálně usnadnit studijní proces předcházející úspěšnému složení zkoušek odborné způsobilosti. Aplikace využívá oficiálně zveřejněných otázek Ministerstva vnitra.',
    // Download links
    googleLink: 'https://play.google.com/store/apps/details?id=com.metastream.zbrojniprukazplus',
    appstoreLink: 'https://apps.apple.com/us/app/zbrojn%C3%AD-pr%C5%AFkaz-plus/id1629079861',
    // Advantages
    advantages: [1, 1, 1, 1],
    // AppOffers
    offers: [<>Všechny <b>aktuální otázky</b> k souhrnné zkoušce odborné způsobilosti, kterou je nutno složit pro získání jakéhokoliv typu zbrojního průkazu</>,
    <>Řadu studijních módů, které uchazeči o zbrojní průkaz maximálně <b>usnadní a zkrátí proces přípravy</b></>,
    <><b>Tematické rozčlenění studijních okruhů</b>, které uživateli umožní ucelit si představu o celé studijní problematice</>,
    <>Možnost vyzkoušet si <b>závěrečnou zkoušku nanečisto</b></>,
    <><b>Statistiky</b> úspěšnosti</>,
    <>Využití studijní metody "<b>spaced repetition</b>"</>,
    <>Možnost promíchání otázek</>],
    offersImage: Zbroj,
    // Often asked
    oftenAsked
},
{
    color: navbarBlue,
    link: '/straznik',
    // Header
    img: ManImg,
    smTitle: <>Zkouška strážníka</>,
    title: <>S aplikací zvládnete profesní zkoušku snadno</>,
    text: <>Usnadněte si přípravu na profesní zkoušku strážníka</>,
    buttonText: <>Stáhnout</>,
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Zkouška strážníka',
    dText: 'Připravte se na profesní zkoušku strážníka s aplikací Zkouška strážníka! Tato aplikace je navržena tak, aby vám pomohla zvládnout zkoušku strážníka obecní policie snadno a efektivně. S intuitivním rozhraním a pravidelnými aktualizacemi otázek je Zkouška strážníka ideálním pomocníkem pro každého, kdo chce uspět u obecní policie. Stáhněte si aplikaci ještě dnes a začněte se připravovat na svou budoucí kariéru!',
    // Download links
    googleLink: 'https://play.google.com/store/apps/details?id=com.metastream.zkouskastraznika',
    appstoreLink: 'https://apps.apple.com/ca/app/zkou%C5%A1ka-str%C3%A1%C5%BEn%C3%ADka/id6744531133',
    // Advantages
    advantages: [0, 0, 0, 0],
    // AppOffers
    offers: [<>Všechny <b>aktuální otázky</b> k profesní zkoušce strážníka obecní policie</>,
    <>Řadu studijních módů, které uchazeči o místo strážníka obecní policie maximálně <b>usnadní a zkrátí proces přípravy</b></>,
    <><b>Tematické rozčlenění studijních okruhů</b>, které uživateli umožní ucelit si představu o celé studijní problematice</>,
    <>Možnost vyzkoušet si <b>závěrečnou zkoušku nanečisto</b></>,
    <><b>Statistiky</b> úspěšnosti</>,
    <>Využití studijní metody "<b>spaced repetition</b>"</>,
    <>Možnost promíchání otázek</>],
    offersImage: Straz,
    // Often asked
    oftenAsked
},
/*{
    color: navbarBlue,
    link: '/urednik',
    // Header
    img: WomanImg,
    smTitle: <>Úřednická zkouška</>,
    title: <>S aplikací zvládnete úřednickou zkoušku snadno</>,
    text: <>Usnadněte si přípravu na profesní úřednickou zkoušku</>,
    buttonText: <>Stáhnout</>,
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Úřednická zkouška',
    dText: <>Aplikace Úřednická zkouška je navržena tak, aby vám pomohla <b>zvládnout zkoušku snadno a efektivně</b>. S intuitivním rozhraním a pravidelnými aktualizacemi otázek je ideálním pomocníkem pro každého budoucího úředníka. Stáhněte si aplikaci ještě dnes a začněte se připravovat na svou budoucí kariéru.</>,
    // Download links
    googleLink: 'https://play.google.com/store/apps/details?id=com.metastream.urednik',
    appstoreLink: 'https://apps.apple.com/us/app/%C3%BA%C5%99ednick%C3%A1-zkou%C5%A1ka/id6747709263',
    // Advantages
    advantages: [0, 0, 0, 0],
    // AppOffers
    offers: [<>Otázky obecné části zkoušky <b>včetně správných odpovědí</b></>,
    <>Řadu <b>studijních módů</b>, které maximálně usnadní a zkrátí proces přípravy</>,
    <>Tematické rozčlenění studijních okruhů</>,
    <>Možnost vyzkoušet si <b>závěrečnou zkoušku nanečisto</b></>,
    <>Statistiky úspěšnosti</>,],
    offersImage: Urednik,
    // Often asked
    oftenAsked
},*/
{
    color: appGreen,
    link: '/rybar',
    // Header
    img: OldImg,
    smTitle: <>Zkouška rybáře</>,
    title: <>Získejte rybářský lístek snadno</>,
    text: <>Usnadněte si přípravu k získání rybářského lístku a začněte rybařit!</>,
    buttonText: <>Stáhnout</>,
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Rybářské zkoušky',
    dText: 'Připravte se na zkoušku pro získání rybářského lístku (ČR) s aplikací Rybářské zkoušky! Aplikace je navržena tak, aby vám usnadnila přípravu na testy rybářských znalostí a pomohla vám zvládnout zkoušku efektivně a bez stresu. S přehledným rozhraním a pravidelnými aktualizacemi je aplikace ideálním pomocníkem pro každého, kdo chce získat rybářský lístek nebo si osvěžit znalosti. Stáhněte si aplikaci ještě dnes a připravte se na úspěšný vstup do světa rybolovu!',
    // Download links
    googleLink: 'https://play.google.com/store/apps/details?id=com.metastream.rybar',
    appstoreLink: 'https://apps.apple.com/ca/app/ryb%C3%A1%C5%99sk%C3%A9-zkou%C5%A1ky/id6745004247',
    // Advantages
    advantages: [1, 1, 1, 1],
    // AppOffers
    offers: [<>Všechny <b>aktuální otázky</b>, se kterými se můžete setkat u zkoušky předcházející získání rybářského lístku</>,
    <>Řadu studijních módů, které uchazeči o rybářský lístek maximálně <b>usnadní a zkrátí proces přípravy</b></>,
    <><b>Tematické rozčlenění studijních okruhů</b>, které uživateli umožní ucelit si představu o celé studijní problematice</>,
    <>Možnost vyzkoušet si <b>závěrečnou zkoušku nanečisto</b></>,
    <><b>Statistiky</b> úspěšnosti</>,
    <>Využití studijní metody "<b>spaced repetition</b>"</>,
    <>Možnost promíchání otázek</>],
    offersImage: Fish,
    // Often asked
    oftenAsked
},
{
    color: navbarBlue,
    link: '/profesak',
    // Header
    img: ManImg,
    smTitle: <>Profesní průkaz</>,
    title: <>S aplikací získáte profesní průkaz snadno</>,
    text: <>Usnadněte si přípravu k získání profesního průkazu</>,
    buttonText: <>Stáhnout</>,
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Profesní průkaz',
    dText: 'Tato aplikace je vytvořena pro všechny, kdo chtějí snadno a efektivně zvládnout zkoušku pro získání profesního průkazu skupin C, D nebo E. Díky přehlednému rozhraní a pravidelným aktualizacím je aplikace ideálním nástrojem pro každého, kdo chce uspět u zkoušky a získat profesní průkaz.',
    // Download links
    googleLink: 'https://play.google.com/store/apps/details?id=com.metastream.profesniprukaz',
    appstoreLink: 'https://apps.apple.com/ca/app/profesn%C3%AD-pr%C5%AFkaz/id6745029379',
    // Advantages
    advantages: [1, 0, 0, 0],
    // AppOffers
    offers: [<>Všechny <b>aktuální otázky</b></>,
    <>Řadu <b>studijních módů</b>, které uchazeči o profesní průkaz maximálně <b>usnadní a zkrátí proces přípravy</b></>,
    <><b>Tematické rozčlenění studijních okruhů</b>, které uživateli umožní ucelit si představu o celé studijní problematice</>,
    <>Možnost vyzkoušet si <b>závěrečnou zkoušku nanečisto</b></>,
    <><b>Statistiky</b> úspěšnosti</>,
    <>Využití studijní metody "<b>spaced repetition</b>"</>,
    <>Možnost promíchání otázek </>],
    offersImage: Profesak,
    // Often asked
    oftenAsked
}];
//#endregion
//#region Candy Math

export const candyMathPage = {
    color: appDarkBlue,
    link: '/candymath',
    // Header
    img: CandyTitle,
    smTitle: <>Matematika hrou</>,
    title: <>Candy Math</>,
    text: <>Matematika hrou pro děti</>,
    buttonText: <>Stáhnout</>,
    // Download links
    googleLink: 'https://play.google.com/store/apps/details?id=com.metastream.candymath',
    appstoreLink: 'https://apps.apple.com/vc/app/candy-math/id6736978906',
    // Advantages
    advantages: [0, 0, 0, 0],
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Candy Math',
    dText: 'Candy Math přináší zábavný způsob, jak si procvičit základy matematiky. Vaším úkolem je vybírat z devíti nabízených příkladů vždy ty tři s nejnižším výsledkem. Za správná rozhodnutí získáváte odměny a postupně sledujete, jak se v počítání zlepšujete. Obtížnost si navíc můžete upravit podle svých schopností. Skvělá volba pro všechny, kdo chtějí trénovat matematiku hravou formou.',
    // AppOffers
    offers: [<>Sčítání</>, <>Odečítání</>, <>Násobení</>, <>Dělení</>, <>Porovnávání čísel</>,],
    offersImage: CandyPromo,

};

//#endregion
//#region Gemstone

export const gemstone = {
    color: navbarBlue,
    link: '/gemstone',
    // Header
    img: GemTitle,
    smTitle: <>Seberozvojová hra</>,
    title: <>Gemstone</>,
    text: <>Vytrénujte svou prostorovou představivost zábavnou formou!</>,
    buttonText: <>Stáhnout</>,
    // Download links
    googleLink: 'https://play.google.com/store/apps/details?id=com.metastream.gempuzzle',
    appstoreLink: 'https://apps.apple.com/cz/app/gemstone-block-puzzle/id6738094928',
    // Advantages
    advantages: [0, 0, 0, 0],
    // Description
    dSmall: 'Aplikace',
    dTitle: 'Gemstone',
    dText: 'Tato logická hra je skvělým způsobem, jak u dětí i dospělých rozvíjet prostorové myšlení, logické uvažování a schopnost řešit problémy. Vaším úkolem je skládat drahokamy do předem připravených tvarů. Přitom si zábavnou formou procvičíte soustředění, představivost i trpělivost. Za každý splněný úkol získáváte odměny, které vám umožní odemykat nové drahokamy. Hra Gemstone je smysluplná aktivita na volný čas.',
    // AppOffers
    offers: [<>Rozvíjí prostorové myšlení – Hráči trénují vizuální představivost a práci s tvary.</>, <>Podporuje logické uvažování – Každý level je malý hlavolam.</>, <>Vhodná pro děti i dospělé – Jednoduchý princip, který zabaví všechny věkové kategorie.</>, <>Bezpečná a bez nevhodného obsahu – Ideální volba pro celou rodinu.</>, <>Podporuje soustředění a trpělivost – Učení hrou, která nenásilně posiluje mentální schopnosti.</>, <>Možnost přizpůsobení – Upravte si vzhled hry podle svého vkusu.</>, <>Neomezené úrovně = nekonečné výzvy – Každý den nový hlavolam, nové myšlenkové dobrodružství.</>,],
    offersImage: GemPromo,
};

//#endregion